import { Avatar, Button, Dropdown, message, Space, Tag, Tooltip } from "antd";
import { avatarBg } from "../../../common/helpers";
import { STATUS_ACTIVE } from "../../../constants/constants";
import MessageIcon from "../../../components/icons/MessageIcon";
import PhoneIcon from "../../../components/icons/PhoneIcon";
import ThreeDotsIcon from "../../../components/icons/ThreeDotsIcon";
import { Link } from "react-router-dom";
import CopyIcon from "../../../components/icons/CopyIcon";
import { useState } from "react";

interface Props {
    data: any;
    onDelete: () => void;
    actionOptions: any;
    disableEdit?: boolean
}
const TeamMemberItem = (props: Props) => {
    const { data, disableEdit = false } = props;

    const [messageApi, contextHolder] = message.useMessage()

    const [phoneNumber, setPhoneNumber] = useState(`${data?.contact_number_code} ${data?.contact_number}`);
    const [email, setEmail] = useState(data?.email_id || '')


    const onCopyLink = async (text: string, type: string) => {
        try {
            await navigator.clipboard.writeText(text);
            if (type == "Email") {
                setEmail("Copied")
            } else {
                setPhoneNumber("Copied")
            }
            setTimeout(() => {
                setEmail(data?.email_id || '')
                setPhoneNumber(`${data?.contact_number_code} ${data?.contact_number}`)
            }, 2000);

        } catch (err) {
            console.error('Failed to copy: ', err);
        }

    }

    return (
        <div className="flex bg-[#F9FAFB] p-[8px] rounded-[4px] gap-x-[8px] mb-[10px]">
            {contextHolder}
            <div className="flex gap-x-[8px] flex-1">
                <Avatar style={{ backgroundColor: avatarBg(data?.first_name?.charAt(0)) }}>{data?.first_name?.charAt(0)}</Avatar>
                <div className="flex flex-col gap-y-[4px] flex-1">
                    <Space>
                        <p className="m-0 text-[13px] font-[500]">{data?.first_name} {data?.last_name}</p>
                        <Tag bordered={false} className="capitalize rounded-[12px] font-[500] text-[10px]" color={data?.is_active ? "success" : "blue"}>{data?.is_active ? "Active" : "Invited"}</Tag>
                    </Space>
                    <Space>
                        {data?.isPoc ? (
                            <p className="m-0 text-[12px] font-[500]">POC •</p>
                        ) : (
                            <></>
                        )}
                        <p className="text-[12px] text-[#475467] m-0">{data?.designation}</p>
                    </Space>
                </div>
                <div className="flex gap-x-[8px]">
                    <Tooltip placement="bottom" title={(
                        <div className="text-[12px] text-white flex items-center gap-[4px] hover:opacity-90 cursor-pointer" onClick={() => onCopyLink(data?.email_id, "Email")}>
                            <p className="m-0 text-[12px] max-w-[200px] truncate">{email}</p>
                            {email === "Copied" ? <></> : <CopyIcon />}
                        </div>
                    )}>
                        <Button icon={<MessageIcon />} type="text" size="small" className="leading-[12px] bg-[#EDEDED]" />
                    </Tooltip>
                    <Tooltip placement="bottom" title={(
                        <div className="text-[12px] text-white flex items-center gap-[4px] hover:opacity-90 cursor-pointer" onClick={() => onCopyLink(`${data?.contact_number_code} ${data?.contact_number}`, "Phone number")}>
                            <p className="m-0 text-[12px] max-w-[200px] truncate">{phoneNumber}</p>
                            {phoneNumber === "Copied" ? <></> : <CopyIcon />}

                        </div>
                    )}>
                        <Button icon={<PhoneIcon />} type="text" size="small" className="leading-[12px] bg-[#EDEDED]" />
                    </Tooltip>
                </div>
            </div>
            {!disableEdit ? (
                <Dropdown menu={{ items: props?.actionOptions(data) }}>
                    <Button icon={<ThreeDotsIcon />} type="text" size="small" className="leading-[12px]" />
                </Dropdown>

            ) : (
                <></>
            )}


        </div>
    )
}

export default TeamMemberItem